import { Radio, RadioGroup } from "informed";
import PropTypes from "prop-types";
import React from "react";
import ReactTable from "react-table";
import fetchOnboardings from "../../onboarding/services/fetch_onboarding";
import OnboardingFilters from "./OnboardingFilters";

const EMPTY_FILTERS = {
  course: "",
  fieldStep: "",
  name: "",
  curriculum: "",
};

// Faixa Unicode dos sinais diacriticos combinantes, isolados pelo normalize("NFD").
const isDiacritic = (char) => {
  const code = char.charCodeAt(0);
  return code >= 0x0300 && code <= 0x036f;
};

const normalize = (value) =>
  String(value === null || value === undefined ? "" : value)
    .normalize("NFD")
    .split("")
    .filter((char) => !isDiacritic(char))
    .join("")
    .toLowerCase();

const matchesText = (value, search) =>
  search === "" || normalize(value).includes(normalize(search));

export const filterOnboardings = (onboardings, filters) =>
  onboardings.filter(
    (onboarding) =>
      (filters.course === "" || onboarding.course === filters.course) &&
      (filters.fieldStep === "" ||
        String(onboarding.field_step) === filters.fieldStep) &&
      matchesText(onboarding.name, filters.name) &&
      matchesText(onboarding.curriculum, filters.curriculum)
  );

export const courseOptionsFrom = (onboardings) =>
  Array.from(
    new Set(onboardings.map((o) => o.course).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b, "pt-BR"));

export const fieldStepOptionsFrom = (onboardings) =>
  Array.from(
    new Set(
      onboardings
        .map((o) => o.field_step)
        .filter((step) => step !== null && step !== undefined && step !== "")
        .map(String)
    )
  ).sort((a, b) => Number(a) - Number(b));

class OnboardingForm extends React.Component {
  state = {
    onboardings: [],
    filters: EMPTY_FILTERS,
    page: 0,
  };

  componentDidMount() {
    this.fetchOnboardings();
  }

  mapData = (d) => ({
    value: d.id,
    ...d,
  });

  fetchOnboardings = () => {
    const { params } = this.props;

    fetchOnboardings(params).then((data) => {
      this.setState({
        onboardings: data.map(this.mapData),
      });
    });
  };

  handleFilterChange = (field, value) =>
    this.setState((prevState) => ({
      filters: { ...prevState.filters, [field]: value },
      page: 0,
    }));

  handleClearFilters = () => this.setState({ filters: EMPTY_FILTERS, page: 0 });

  render() {
    const { onboardings, filters, page } = this.state;
    const { onValueChange } = this.props;

    const filteredOnboardings = filterOnboardings(onboardings, filters);

    return (
      <div className="list-base list-base-full">
        <OnboardingFilters
          values={filters}
          courseOptions={courseOptionsFrom(onboardings)}
          fieldStepOptions={fieldStepOptionsFrom(onboardings)}
          visibleCount={filteredOnboardings.length}
          totalCount={onboardings.length}
          onChange={this.handleFilterChange}
          onClear={this.handleClearFilters}
        />
        <RadioGroup field="onboarding" onValueChange={onValueChange}>
          <ReactTable
            data={filteredOnboardings}
            columns={[
              {
                Header: "",
                accessor: "id",
                width: 50,
                Cell: (row) => (
                  <label className="input-radio-type">
                    <Radio
                      value={row.original}
                      id={`finance_plan-${row.value}`}
                    />
                    <span className="radiomark mt-0" />
                  </label>
                ),
              },
              {
                Header: "Curso",
                accessor: "course",
              },
              {
                Header: "Processo",
                accessor: "name",
              },
              {
                Header: "Currículo",
                accessor: "curriculum",
              },
              {
                Header: "Ano / Período de promoção",
                accessor: "field_step",
              },
            ]}
            defaultPageSize={10}
            pageSize={5}
            page={page}
            onPageChange={(nextPage) => this.setState({ page: nextPage })}
            noDataText="Nenhum processo encontrado com esses filtros"
            className="table-default -striped -highlight"
          />
        </RadioGroup>
      </div>
    );
  }
}

OnboardingForm.propTypes = {
  params: PropTypes.shape({
    curriculum: PropTypes.string,
    course: PropTypes.string,
    field_step: PropTypes.string,
  }),
  onValueChange: PropTypes.func.isRequired,
};

OnboardingForm.defaultProps = {
  params: {},
};

export default OnboardingForm;
